import { forwardRef } from 'react';
import type { IconBaseProps } from '../types.js';

export const GatorScore = forwardRef<SVGSVGElement, IconBaseProps>(
  ({ className, size = 24, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.8" />
      <path d="M12 12L16.8 9.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M8 16.2C9.2 17.1 10.5 17.5 12 17.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="12" cy="12" r="1.3" fill="currentColor" />
    </svg>
  ),
);

GatorScore.displayName = 'gator-score';
